export const MERGE_ENTITIES = 'MERGE_ENTITIES';
export const REPLACE_ENTITIES = 'REPLACE_ENTITIES';
export const REMOVE_ENTITIES = 'REMOVE_ENTITIES';
export const RESET_ENTITIES = 'RESET_ENTITIES';
export const UPDATE_ENTITIES = 'UPDATE_ENTITIES';